/*
 * Authors: Jakub, mariushirjanu
 * Created: 26/01/2018
 */
import { Injectable } from '@angular/core';
import * as _ from 'underscore';

import { HttpDataService } from '../../../shared/http/http-data.service';

enum JobStatus {
  // noinspection JSUnusedGlobalSymbols
  CANCEL,
  ERROR,
  DONE,
  TODO,
  BUSY
}

const busyStatuses = [
  JobStatus[ JobStatus.TODO ],
  JobStatus[ JobStatus.BUSY ]
];
const CANCELID_SYNC_BUSY = `sync-busy`;

@Injectable()
export class CatalogSyncDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {/***/
  }

  public sync(webshopId:number):Promise<number> {
    const url:string = `rest/webshops/${webshopId}/sync`;
    return this.httpDataService.doPOST(url, undefined, undefined, undefined, 'Error starting catalog sync');
  }

  public syncBusy(webshopId:number):Promise<boolean> {
    const url:string = `rest/webshops/${webshopId}/sync`;
    return this.httpDataService.doGET(url, undefined, undefined, 'Error loading catalog sync status', CANCELID_SYNC_BUSY)
      .then((jobStatus:string) => _.contains(busyStatuses, jobStatus));
  }

  public cancelSyncBusyRequests() {
    this.httpDataService.cancelRequests(CANCELID_SYNC_BUSY);
  }
}